import { Button } from "react-bootstrap";
import { Box, Table } from "../../../../../../../components";
import { DateHelper, StringHelper } from "../../../../../../../helper";
import {
  EmployeeConfigType,
  EmployeeRoleService,
} from "../../../../../../../services/config/permission-config/employeeRole";
import { useConfigEmployee } from "../../../hooks/use-config-employee";
import { Modal, Space, Tooltip } from "antd";
import { HiOutlineTrash } from "react-icons/hi2";
import { EmployeeConfigForm } from "./employee-config";
import { useState } from "react";
import { useSearchParams } from "../../../../../../../hook/use-search-params";
import { useQueryClient } from "@tanstack/react-query";
import { CreateNotification } from "../../../../../../../components/notifier";

export const PermissionGrant = () => {
  const { data, isLoading } = useConfigEmployee();
  const [selectedItem, setSelectedItem] = useState(null as any);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddUser, setIsAddUser] = useState(false);
  const { searchParams } = useSearchParams();
  const { addEmployee } = useConfigEmployee();
  const queryClient = useQueryClient();
  const menuId = searchParams.get("menuId") || "54";

  // const onEdit = (record: any) => {
  //   setIsAddUser(false);
  //   const employee = data.find((e: any) => e.email === record.email);
  //   setSelectedItem(employee);
  //   setTimeout(() => setIsModalOpen(true), 0);
  // };

  const renderAddUserNotify = (e: any) => {
    if (e.statusCode === 200) {
      CreateNotification({
        title: "Thành công",
        body: `Thêm thành viên ${e.email} thành công`,
        icon: "/icons/success.png",
      });
    } else if (e.statusCode === 400) {
      const notifyContent = StringHelper.verticalBarSplit(e.message)[1];
      CreateNotification({
        title: "Thành công",
        body: `User đã tồn tại trong nhóm ${notifyContent}`,
        icon: "/icons/warning.png",
      });
    }
  };

  const onSubmit = async (e: any) => {
    if (isAddUser) {
      if (e.employee) {
        const employees = [...e.employee];
        const res = await addEmployee(employees, menuId);
        if (res?.length > 0) {
          res.forEach((e: any) => renderAddUserNotify(e));
        }
        await queryClient.invalidateQueries({ queryKey: ["config-employee"] });
      }
      setIsAddUser(false);
      setIsModalOpen(false);
      queryClient.invalidateQueries({ queryKey: ["config-role"] });
    } else {
      const { createdDate, name, ...params } = e;
      const fields = {
        ...params,
        description: e.name,
        roleId: menuId,
      };
      const res = await EmployeeRoleService.updateEmployeeRole(fields);
      if (res.statusCode === 200) {
        CreateNotification({
          title: "Thành công",
          body: "Cập nhật thông tin thành viên thành công",
          icon: "/icons/success.png",
        });
      } else if (res.statusCode === 400) {
        const notifyContent = StringHelper.verticalBarSplit(res.message)[1];
        CreateNotification({
          title: "Thành công",
          body: `User đã tồn tại trong nhóm ${notifyContent}`,
          icon: "/icons/warning.png",
        });
      }
      setIsModalOpen(false);
      await queryClient.invalidateQueries({ queryKey: ["config-employee"] });
    }
  };

  const onCloseModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
    setIsAddUser(false);
  };

  const openAddUserModal = () => {
    setIsModalOpen(true);
    setIsAddUser(true);
  };

  const onRemove = async (id: string) => {
    try {
      await EmployeeRoleService.deleteEmployeeRole(+id);
      CreateNotification({
        title: "Thành công",
        body: "Xoá thành viên thành công",
        icon: "/icons/success.png",
      });
      queryClient.invalidateQueries({ queryKey: ["config-employee"] });
    } catch (error) {}
  };

  const showDeleteConfirm = (id: string) => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        onRemove(id);
      },
    });
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center" as const,
    },
    {
      title: "Họ tên",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
    },
    {
      title: "Ngày thêm",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: string) => DateHelper.formatDateToString(date),
    },
    {
      key: "action",
      dataIndex: "action",
      width: 30,
      align: "left" as const,
      render: (_: string, record: any) => (
        <Space>
          {/* <Tooltip title="Chỉnh sửa">
            <HiPencilSquare size={20} className="cursor-pointer" color="#0ea5e9" onClick={() => onEdit(record)} />
          </Tooltip> */}
          <Tooltip title="Xoá">
            <HiOutlineTrash
              size={20}
              className="cursor-pointer"
              color="#dc2626"
              onClick={() => showDeleteConfirm(record.id)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const dataSource = data.map((e: EmployeeConfigType, index: number) => ({
    index: index + 1,
    ...e,
  }));

  return (
    <Box
      title={"Thành viên"}
      style={{ borderRadius: 0, flex: 3, marginBottom: 0, marginLeft: "5px", overflow: "auto" }}
      titleRight={
        <Button style={{ margin: "10px", marginLeft: 0, float: "right" }} variant="primary" onClick={openAddUserModal}>
          Thêm thành viên
        </Button>
      }
    >
      <Table bordered dataSource={dataSource} columns={columns} rowClassName="editable-row" loading={isLoading} />
      <Modal
        width={1000}
        title={<div style={{ fontSize: 18 }}>{selectedItem ? "Chỉnh sửa nhân viên" : "Thêm nhân viên mới"}</div>}
        open={isModalOpen}
        footer={null}
        onCancel={onCloseModal}
        destroyOnClose
      >
        <EmployeeConfigForm employee={selectedItem} onSubmit={onSubmit} isAddUser={isAddUser} />
      </Modal>
    </Box>
  );
};
